import { ReactNode } from 'react';

import { Link } from '@mui/material';

import { Icons, LinkBehaviour, Typography, Stack } from '@cast/design-system';

import { Link as RouterLink } from 'components/router';

import { WorkloadDetailsBreadcrumbs } from './WorkloadDetailsBreadcrumbs';

type Props = {
  workloadName: string;
  woopLink?: string;
  actions?: ReactNode;
};

export const WorkloadDetailsTitle = ({
  workloadName,
  woopLink,
  actions,
}: Props) => {
  return (
    <Stack gap={12} width="100%">
      <WorkloadDetailsBreadcrumbs workloadName={workloadName || ''} />

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        {woopLink ? (
          <Link
            to={woopLink}
            component={RouterLink}
            underline="none"
            data-testid="workload-name-link"
          >
            <LinkBehaviour
              secondaryAction
              variant="h3"
              data-testid="workload-name"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              {workloadName}
              <Icons.ArrowSquareOut size={28} color="currentColor" />
            </LinkBehaviour>
          </Link>
        ) : (
          <Typography variant="h3" data-testid="workload-name">
            {workloadName}
          </Typography>
        )}

        {actions}
      </Stack>
    </Stack>
  );
};
